export enum AlarmTypeEnum {
  MASTER_CALL = 0,
  DISORDER = 1,
}

export enum AlarmPriorityEnum {
  LWO = 0,
  MID = 1,
  HIGH = 2
}